// Save about 1mb by importing prism-light & needed languages instead of all react-syntax-highlighter.
import csharp from 'react-syntax-highlighter/dist/cjs/languages/prism/csharp';
import java from 'react-syntax-highlighter/dist/cjs/languages/prism/java';
import javascript from 'react-syntax-highlighter/dist/cjs/languages/prism/javascript';
import jsx from 'react-syntax-highlighter/dist/cjs/languages/prism/jsx';
import kotlin from 'react-syntax-highlighter/dist/cjs/languages/prism/kotlin';
import php from 'react-syntax-highlighter/dist/cjs/languages/prism/php';
import python from 'react-syntax-highlighter/dist/cjs/languages/prism/python';
import ruby from 'react-syntax-highlighter/dist/cjs/languages/prism/ruby';
import swift from 'react-syntax-highlighter/dist/cjs/languages/prism/swift';
import json from 'react-syntax-highlighter/dist/cjs/languages/prism/json';
import dart from 'react-syntax-highlighter/dist/cjs/languages/prism/dart';

export const SUPPORTED_LANGUAGES: { name: string; value: unknown }[] = [
  { name: 'csharp', value: csharp },
  { name: 'java', value: java },
  { name: 'javascript', value: javascript },
  { name: 'jsx', value: jsx },
  { name: 'kotlin', value: kotlin },
  { name: 'php', value: php },
  { name: 'ruby', value: ruby },
  { name: 'python', value: python },
  { name: 'swift', value: swift },
  { name: 'json', value: json },
  { name: 'dart', value: dart },
];
